<template>
  <div
    class="employee-item"
    :class="{
      'selected': employee.Is_Selected
    }"
  >
    <v-row class="align-center flex-nowrap" dense>
      <v-col cols="auto" class="pr-0">
        <v-checkbox
          dense
          hide-details
          class="pa-0 ma-0"
          :input-value="employee.Is_Selected"
          @change="updateSelection"
        ></v-checkbox>
      </v-col>
      <v-col
        cols="1"
        class="d-flex align-center pl-0 flex-grow-1 flex-shrink-0"
        style="min-width: 100px; max-width: 100%"
        @click="toggleSelection"
      >
        <v-icon class="mr-2" color="primary">
          mdi-account
        </v-icon>
        <div class="d-flex align-center flex-grow-1" style="min-width: 0;">
          <span class="text-subtitle-1 mr-2 text-truncate">{{ employee.Full_Name }}</span>

          <div class="d-flex align-center flex-shrink-1" style="min-width: 0;">
            <template v-if="hasLabels">
              <v-chip
                v-for="labelId in visibleLabelIds"
                :key="labelId"
                x-small
                class="mr-1 mb-0 flex-shrink-0"
                :color="getLabelColor(labelId)"
                text-color="white"
                style="height: 18px; max-width: 80px;"
              >
                <span class="chip-text">{{ getLabelName(labelId) }}</span>
              </v-chip>

              <v-btn
                v-if="hiddenLabelsCount > 0"
                x-small
                icon
                class="ml-1 flex-shrink-0"
                @click.stop="showAllLabelsPopup = true"
                style="min-width: 24px;"
              >
                <v-icon x-small>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-dialog
      v-model="showAllLabelsPopup"
      max-width="300"
      content-class="labels-popup"
    >
      <v-card>
        <v-card-title class="text-subtitle-2 pa-3">
          Labels for {{ employee.Full_Name }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-3">
          <div class="d-flex flex-wrap">
            <v-chip
              v-for="labelId in allLabelIds"
              :key="labelId"
              x-small
              class="mr-1 mb-1 popup-text"
              :color="getLabelColor(labelId)"
              text-color="white"
            >
              {{ getLabelName(labelId) }}
            </v-chip>
            <div
              v-if="!hasLabels"
              class="text-caption text--disabled"
            >
              No labels assigned
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="pa-2">
          <v-spacer></v-spacer>
          <v-btn
            small
            text
            color="primary"
            @click="showAllLabelsPopup = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'EmployeeItem',
  props: {
    employee: {
      required: true,
      type: Object
    },
    value: {
      required: false,
      type: Object,
      default: () => {
        return {
          selectedEmployee: []
        }
      }
    },
    labels: {
      type: Array,
      default: () => []
    },
    activeFilters: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showAllLabelsPopup: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    allLabelIds () {
      const employeeLabels = this.employee.Label_IDs || []
      if (!Array.isArray(employeeLabels)) return []

      if (this.activeFilters.length === 0) {
        return employeeLabels
      }
      return employeeLabels.filter(id => this.activeFilters.includes(id))
    },
    hasLabels () {
      return this.allLabelIds.length > 0
    },
    visibleLabelIds () {
      return this.allLabelIds.slice(0, 2)
    },
    hiddenLabelsCount () {
      return Math.max(0, this.allLabelIds.length - 2)
    }
  },
  methods: {
    updateSelection (isSelected) {
      this.$set(this.employee, 'Is_Selected', isSelected)
      const currentSelected = [...this.value.selectedEmployee]
      const employeeId = this.employee.Employee_ID
      const index = currentSelected.indexOf(employeeId)

      if (isSelected && index === -1) {
        currentSelected.push(employeeId)
      } else if (!isSelected && index > -1) {
        currentSelected.splice(index, 1)
      }

      this.$emit('input', {
        ...this.value,
        selectedEmployee: currentSelected
      })
    },
    toggleSelection () {
      this.updateSelection(!this.employee.Is_Selected)
    },
    getLabelName (labelId) {
      if (!this.labels || !Array.isArray(this.labels)) return ''
      const label = this.labels.find(l => l.Label_ID === labelId)
      return label ? label.Label_Name : ''
    },
    getLabelColor (labelId) {
      const colors = [
        '#2196F3', '#4CAF50', '#FF9800', '#E91E63',
        '#9C27B0', '#00BCD4', '#8BC34A', '#FF5722',
        '#795548', '#607D8B', '#3F51B5', '#009688'
      ]
      return colors[Math.abs(labelId) % colors.length] || '#757575'
    }
  }
}
</script>

<style lang="scss" scoped>
.employee-item {
  cursor: pointer;
  user-select: none;
  transition: background-color .15s ease-in-out;
  padding: 4px 0;

  &:hover {
    background-color: rgba(#d7d7d7, .3);
  }
}

.chip-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  font-size: 13px;
  line-height: 1.2;
}

.popup-text {
  font-size: 13px;
}
</style>
